import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Loading } from 'core';
import { useToast } from 'core/components/toast';
import { Card } from 'core/components/card';
import { useStore } from 'core/store/store.mobx';
import MicroDepositsForm from './micro-deposits-form';
import useStyles from './microdeposits.styles';

const MicroDeposits = () => {
  const classes = useStyles();
  const {
    account: {
      policies: { achPoliciesWithUniqueBankId, getPoliciesNeedingStripeBankVerification, loading }
    }
  } = useStore();
  const toast = useToast();

  // get list of policy ids we need info for
  const policyIdsNeedingVerifying = getPoliciesNeedingStripeBankVerification();

  if (!policyIdsNeedingVerifying?.length) {
    return null;
  }

  if (loading && policyIdsNeedingVerifying?.length) {
    return (
      <Card className={classes.loadingCard}>
        <Loading noBackground />
      </Card>
    );
  }

  if (achPoliciesWithUniqueBankId?.length && policyIdsNeedingVerifying?.length) {
    // map over unique policies so long as it is in policiesNeedingVerifying
    return achPoliciesWithUniqueBankId?.map((policy) => {
      if (policyIdsNeedingVerifying.includes(policy.id)) {
        return (
          <Grid item key={`${policy.id}-microdeposits-grid`} className={classes.bottomSpacing}>
            <MicroDepositsForm key={`${policy.id}-microdeposits`} policyId={policy.id} toast={toast} />
          </Grid>
        );
      }
      return null;
    });
  }

  return null;
};

MicroDeposits.propTypes = {
  accountId: PropTypes.string
};

export default observer(MicroDeposits);
